import { render, staticRenderFns } from "./messageIcon.vue?vue&type=template&id=6d86fb32&scoped=true"
import script from "./messageIcon.vue?vue&type=script&lang=js"
export * from "./messageIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86fb32",
  null
  
)

export default component.exports